var _path, _path2, _g, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTagNew = function SvgTagNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 14,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tag_new_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F35757",
    d: "M28 7a7 7 0 0 0-7-7H8a8 8 0 0 0-8 8v5a1 1 0 0 0 1 1h20a7 7 0 0 0 7-7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "tag_new_svg__b",
    width: 18,
    height: 11,
    x: 4,
    y: 2,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M4.052 2h17v10.461h-17z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#tag_new_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m20.884 6.032-2.004 4.962h-1.705q.112-.91.34-2.397-.246.654-.544 1.32l-.471 1.077h-1.709l.711-4.962h1.354q-.039.195-.445 2.842.101-.274 1.141-2.842h1.3l-.47 2.841q.42-1.245 1.15-2.841zM14.152 8.48H12l-.315 1.2q-.098.375-.074.485.026.108.177.108a.34.34 0 0 0 .291-.144q.102-.144.21-.558l.193-.731h1.576l-.107.41q-.135.513-.271.79a2.3 2.3 0 0 1-.454.589q-.316.313-.718.47a2.6 2.6 0 0 1-.945.156q-.526 0-.89-.154-.361-.155-.516-.424a1.2 1.2 0 0 1-.154-.593q-.001-.324.161-.943l.425-1.617q.192-.727.495-1.147t.803-.644 1.071-.224q.7 0 1.084.27t.45.714-.146 1.252zm-1.375-1.989q-.173 0-.242.107-.069.106-.192.574l-.107.406h.486l.107-.406q.112-.43.1-.556-.012-.125-.152-.125M10.8 5.18c-.25.19-.549.478-.745.83-.197.353-.336.854-.476 1.37L9.111 9.1q-.18.659-.177 1.003 0 .345.17.631c.113.192.245.438.511.547.011.005.07.04.047.04v.037H7.667l-.122-3.8-1.062 3.8H4.579L6.916 3h1.903l.225 3.763L10.096 3h1.903l-.458 1.741c-.113.033-.49.248-.74.439"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.712 2.19a.097.097 0 0 1 .176 0l.466 1.009q.015.031.047.047l1.009.466a.097.097 0 0 1 0 .176l-1.009.466a.1.1 0 0 0-.047.047l-.466 1.009a.097.097 0 0 1-.176 0L22.246 4.4a.1.1 0 0 0-.047-.047l-1.009-.466a.097.097 0 0 1 0-.176l1.009-.466a.1.1 0 0 0 .047-.047zM23.951 7.106a.054.054 0 0 1 .098 0l.259.56q.008.018.026.026l.56.26a.054.054 0 0 1 0 .097l-.56.259a.05.05 0 0 0-.026.026l-.26.56a.054.054 0 0 1-.097 0l-.259-.56a.05.05 0 0 0-.026-.026l-.56-.26a.054.054 0 0 1 0-.097l.56-.259a.05.05 0 0 0 .026-.026z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "tag_new_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28v14H0z"
  })))));
};
export default SvgTagNew;